<template>
  <el-card shadow="always" width="100%" style="height: 100%" :body-style="{ padding: '0px' }">
    <div class="row bg-electric-blue py-3 px-3">
      <div class="col-12 d-flex justify-content-between">
        <h3 class="mb-0 text-white">Upcoming Invoices</h3>
        <i role="button" class="el-icon fa-lg mt-1 has-interaction text-white" @click="showData = !showData"
          :class="showData ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"></i>
      </div>
    </div>
    <div class="row p-2" v-loading="loading" v-if="showData">
      <div class="col-12 p-0">
        <el-table :data="sales.data" :cell-class-name="saleClassStatus" @cell-click="handleCellClick">
          <el-table-column label="Invoice #" prop="id" width="100px">
            <template slot-scope="scope">
              <a href="#" @click="$event.preventDefault()">{{ scope.row.ref_id }}</a>
            </template>
          </el-table-column>
          <el-table-column label="Producer" prop="id" min-width="100px">
            <template slot-scope="scope">
              {{ scope.row.business.short_name }}
            </template>
          </el-table-column>
          <el-table-column label="Reason" prop="invoice_type.name"></el-table-column>
          <el-table-column label="Sold Date" prop="sold_at">
            <template slot-scope="scope">
              {{ scope.row.sold_at ? moment(scope.row.sold_at).format('DD/MM/YYYY') : '' }}
            </template>
          </el-table-column>
          <el-table-column label="Number of Head" prop="number_of_head"></el-table-column>
          <el-table-column label="Value" prop="sale_value">
            <template slot-scope="scope">
              <span v-if="[3, 7, 8].includes(scope.row.sale_status_id)">${{ $_toLocaleString(scope.row.sale_value, 2)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Due Date" prop="confirmed_settlement_date">
            <template slot-scope="scope">
              {{ scope.row.confirmed_settlement_date ? moment(scope.row.confirmed_settlement_date).format('DD/MM/YYYY') :
                '--' }}
              <!--upcoming-invoices-settlement-date :initial_sale="scope.row"></upcoming-invoices-settlement-date-->
            </template>
          </el-table-column>
          <el-table-column label="" prop="sale_status_id">
            <template slot-scope="scope">
              <div
                v-if="(![8].includes(scope.row.sale_status_id)) && moment(moment().format('Y-MM-DD')).isAfter(moment(scope.row.confirmed_settlement_date).format('Y-MM-DD'))"
                class="btn-danger text-center rounded" style="width: 60px;">
                Overdue
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100px" label="Status" prop="sale_status_id">
            <template slot-scope="scope">
              <div class="text-center rounded alert p-0 m-0" :class="'alert-' + saleStatus(scope.row).tag_type">{{
                saleStatus(scope.row).new_name
              }}</div>
            </template>
          </el-table-column>
        </el-table>
        <div class="py-3 px-1 d-flex justify-content-center justify-content-xl-end">
          <el-pagination small layout="prev, pager, next" :current-page.sync="currentPage"
            @current-change="handleCurrentChange" :background="false" :page-size="perPage" :page-count="sales.last_page"
            :total="sales.total" />
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import Formatter from "../../../../mixins/OttleyFormatter";
import Sale from "../../../modelsPortal/Sale";
import Invoice from "../../../modelsPortal/Invoice";
import SaleStatuses from "../../../../constants/SaleStatuses.js";
import UpcomingInvoicesSettlementDate from './UpcomingInvoicesSettlementDate.vue';
export default {
  components: { UpcomingInvoicesSettlementDate },
  mixins: [Formatter],
  props: {
  },
  mounted() {
    this.getSales();
  },
  data() {
    return {
      sales: [],
      loading: false,
      page: 1,
      currentPage: 1,
      perPage: 10,
      printOrderLoading: false,
      showData: true,
    };
  },
  methods: {
    saleStatus(sale) {
      let statuses = Object.keys(SaleStatuses).map((key) => {
        return SaleStatuses[key];
      });

      let status_id = statuses.find(
        (x) => x.id == sale.sale_status_id
      );

      if ([1, 2].includes(sale.sale_status_id)) {
        status_id = { new_name: 'Pending', tag_type: 'warning' };
      }

      if ([3, 7].includes(sale.sale_status_id)) {
        status_id = { new_name: 'Awaiting Payment', tag_type: 'success' };
      }

      return status_id;
    },
    handleCellClick(row, column, cell, event) {
      if (column.property != 'confirmed_settlement_date' && ![1, 2].includes(row.sale_status_id))
        window.open(row.invoice_html_url, '_blank');
    },
    saleClassStatus({ row, column }) {
      let className = 'has-interaction';
      if ((![8].includes(row.sale_status_id)) && moment(moment().format('Y-MM-DD')).isAfter(moment(row.confirmed_settlement_date).format('Y-MM-DD')))
        className += ' alert alert-danger rounded-0 border-left-0 border-right-0';

      return className;
    },
    sale_status(sale) {
      let statuses = Object.keys(SaleStatuses).map((key) => {
        return SaleStatuses[key];
      });

      return statuses.find((x) => x.id == sale.sale_status_id);
    },
    getSales(
      page = 1,
    ) {
      this.loading = true;

      let sales = Sale.page(page)
        .select(
          "id",
          "ref_id",
          "business_id",
          "confirmed_settlement_date",
          "sale_status_id",
          "value",
          "agent_settlement_date",
          "invoice_type_id",
          "sold_at",
          "number_of_head"
        )
        .where('client_portal_status', true)
        .append("sale_value", "invoice_html_url")
        .include("business", "invoiceType")
        .params({ 'per_page': this.perPage })
        .orderBy("confirmed_settlement_date");

      sales
        .get()
        .then((res) => {
          this.loading = false;
          this.sales = res;
          this.currentPage = page;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    handleCurrentChange(page = 1) {
      this.getSales(page);
    },
    getInvoice(event, sale) {
      event.preventDefault();
      this.loading = true;
      new Invoice({ sale_id: sale.id })
        .for(new Sale(sale))
        .save()
        .then((result) => {
          this.loading = false;
          window.open(res.media[0].url, "_blank"); // open
        }).catch((err) => {
          this.loading = false;
        });
    }
  },
};
</script>